import {
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { CustomEvent } from "schemas/functions";

interface Props {
  description: string;
  answer: string;
  handleChange: (field: string, answer: string) => void;
}

const CancelQuestion = ({ answer, description, handleChange }: Props) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent={"space-between"}
      sx={{ mb: 2 }}
    >
      <Grid item xs={12} md={9}>
        <Typography sx={{ fontSize: 16 }}>{description}</Typography>
      </Grid>

      <Grid item xs md container justifyContent={"flex-end"}>
        <ToggleButtonGroup
          color="primary"
          value={answer}
          exclusive
          onChange={(e: CustomEvent) => {
            const { value } = e.target;
            handleChange(description, value);
          }}
          size="small"
        >
          <ToggleButton
            value="Yes"
            sx={[
              { px: 2 },
              answer === "Yes"
                ? {
                    "&.MuiToggleButton-root.Mui-selected": {
                      backgroundColor: "primary.main",
                      color: "white",
                    },
                  }
                : {},
            ]}
          >
            Yes
          </ToggleButton>
          <ToggleButton
            value="No"
            sx={[
              { px: 2 },
              answer === "No"
                ? {
                    "&.MuiToggleButton-root.Mui-selected": {
                      backgroundColor: "primary.main",
                      color: "white",
                    },
                  }
                : {},
            ]}
          >
            No
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
};

export default CancelQuestion;
